<div class="relative flex flex-col gap-1.5 w-full select-none" [class]="className">
  <div
    class="relative flex items-center w-full transition-colors rounded-sm border border-solid min-h-10 px-3 py-1.5"
    [ngClass]="{
      'bg-input-field-bg-default border-input-field-border-disabled opacity-70 cursor-not-allowed': disabled,
      'bg-input-field-bg-active border-input-field-border-error': !disabled && errorMessage,
      'bg-input-field-bg-active border-input-field-border-active': !disabled && !errorMessage && isFocused(),
      'bg-transparent hover:bg-input-field-bg-active border-input-field-border-default hover:border-input-field-border-hover': !disabled && !errorMessage && !isFocused()
    }"
  >
    <!-- Search Magnifying Glass Icon / Loading Spinner -->
    @if (loading) {
      <svg
        class="w-4 h-4 mr-2.5 shrink-0 animate-spin text-text-brand"
        fill="none"
        viewBox="0 0 24 24"
      >
        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
      </svg>
    } @else if (showSearchIcon) {
      <svg
        class="w-4 h-4 mr-2.5 shrink-0 transition-colors"
        [ngClass]="disabled ? 'text-text-dimmed' : (isFocused() ? 'text-text-primary' : 'text-text-dimmed')"
        fill="currentColor"
        stroke="none"
        viewBox="0 0 24 24"
        stroke-width="2"
      >
        <path d="M15.6 7.8C15.6 9.52125 15.0413 11.1112 14.1 12.4012L18.8475 17.1525C19.3162 17.6213 19.3162 18.3825 18.8475 18.8512C18.3787 19.32 17.6175 19.32 17.1488 18.8512L12.4013 14.1C11.1113 15.0412 9.52125 15.6 7.8 15.6C3.49125 15.6 0 12.1087 0 7.8C0 3.49125 3.49125 0 7.8 0C12.1088 0 15.6 3.49125 15.6 7.8ZM7.8 13.2C10.7812 13.2 13.2 10.7812 13.2 7.8C13.2 4.81875 10.7812 2.4 7.8 2.4C4.81875 2.4 2.4 4.81875 2.4 7.8C2.4 10.7812 4.81875 13.2 7.8 13.2Z"/>
      </svg>
    }


    <!-- Input text field -->
    <input
      type="text"
      [value]="value"
      [placeholder]="placeholder"
      [disabled]="disabled"
      (input)="onInput($any($event.target).value)"
      (focus)="onFocus($event)"
      (blur)="onBlur($event)"
      (keydown)="onKeyDown($event)"
      class="w-full bg-transparent text-text-primary placeholder-text-dimmed text-sm outline-none border-none p-0 disabled:cursor-not-allowed disabled:text-text-dimmed disabled:placeholder-text-dimmed"
    />

    <!-- Clear Button (when value exists and clearable is enabled) -->
    @if (clearable && value && !disabled) {
      <button
        type="button"
        (mousedown)="onClear($event)"
        class="ml-2 text-text-dimmed hover:text-text-primary p-0.5 rounded-full hover:bg-white/10 transition-colors shrink-0 cursor-pointer"
        aria-label="Clear search"
      >
        <svg class="w-3.5 h-3.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
          <line x1="18" y1="6" x2="6" y2="18"></line>
          <line x1="6" y1="6" x2="18" y2="18"></line>
        </svg>
      </button>
    }

    <!-- Right Custom Button -->
    @if (buttonLabel) {
      <button
        type="button"
        [disabled]="disabled"
        (click)="onButtonClick($event)"
        class="ml-3 text-sm font-semibold transition-colors shrink-0 cursor-pointer text-text-primary hover:text-text-primary disabled:cursor-not-allowed disabled:text-text-dimmed"
      >
        {{ buttonLabel }}
      </button>
    }
  </div>

  <!-- Error Message Banner below input -->
  @if (errorMessage && !disabled) {
    <div class="flex items-center gap-1.5 text-xs text-text-destructive font-medium pt-0.5">
      <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor" class="shrink-0">
        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"/>
      </svg>
      <span>{{ errorMessage }}</span>
    </div>
  }
</div>
